/** 财富来源 / 资金来源选「其他」时的码值（与 busConfigs.sourceOfFunds 对齐） */
export const OTHER_CODE = 'OTHER';

/** 资金来源地选「其他」时的码值（与 busConfigs.sourceOfFundsLocation 对齐） */
export const SOURCE_OF_FUNDS_LOCATION_OTHER = 'SOURCE_OF_FUNDS_LOCATION_OTHER';
